export function getElementHeight(id: string) {
    const el = document.getElementById(id);
    if (!el) {
        return 0;
    }
    return Number(window.getComputedStyle(el).height.replaceAll("px", ""));
}